import fetchApi from "../fetchApi";
export const GetMfaBalance = async (id = "") => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(`card-issuing/cardholder/programs/${id}/master_funding_account_balance`, options);
};

